module.exports = __webpack_public_path__ + "img/show.d78a5aa4.svg";